
import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { EditFormBase } from '../../core/helper/EditFormBase';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Location } from '@angular/common';

import { AppConfiguracionEntornoService } from '../../core/services/appConfiguracionEntornoService.service';
import { AppConfiguracionEntorno } from '../../core/models/appConfiguracionEntorno.model';
import { AppImagenesService } from '../../core/services/appImagenes.service';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { LicenseCheckerService } from '../../core/helper/licenseChecker';
import { LivesSessionHelper } from '../../core/helper/livesSessionHelper';



@Component({
  selector: 'app-config-entorno',
  templateUrl: './config-entorno.component.html',
  styleUrls: ['./config-entorno.component.scss'],
  providers: [AppConfiguracionEntornoService, AppImagenesService]
})
export class ConfigEntornoComponent extends EditFormBase<AppConfiguracionEntorno, string> implements OnInit {

  // Propiedades del panel contenedor
  panelIcon = 'cog'; // Material icon
  panelTitle = 'Configuración de valores predeterminados';
  panelDescription = '';

  selectedText: string[];
  textFieldsNotEmpty = false;
  numberOfChanges = 0;
  originalModel: AppConfiguracionEntorno;
  environmentID: string;
  customButtonImageValid: boolean = true;
  customButtonNameValid: boolean = true;
  customButtonAndroidUrlValid: boolean = true;
  customButtonIosUrlValid: boolean = true;
  customButtonAndroidUrlRegex: RegExp = /^(https?:\/\/[^\s/$.?#].[^\s]*|https:\/\/play\.google\.com\/store\/apps\/details\?id=[a-zA-Z0-9._-]+)$/;
  customButtonIosUrlRegex: RegExp = /^(https?:\/\/[^\s/$.?#].[^\s]*|https:\/\/apps\.apple\.com\/[a-z]{2}\/app\/[a-zA-Z0-9._-]+\/id\d+)$/;

  livesHrLicence: boolean;
  conectiaLicence: boolean;

  constructor(
    _route: ActivatedRoute,
    _modelService: AppConfiguracionEntornoService,
    protected _configEntornoService: AppConfiguracionEntornoService,
    protected _imagesService: AppImagenesService,
    _messageDialog: MessageDialog,
    protected _sessionHelper: SessionHelper,
    _router: Router,
    _location: Location,
    private licenseChecker: LicenseCheckerService,
    private _livesSession: LivesSessionHelper,
  ) {
    super(_modelService, _messageDialog, _route, _router, _location, AppConfiguracionEntorno);
    this.getModel();
    //inicializo para evitar errores
    this.model.imageData = { name: '', mimeType: '', base64: '', base64FullData: '' };
    this.model.stampData = { name: '', mimeType: '', base64: '', base64FullData: '' };
  }


  private loadImage(imageId: string): Observable<any> {
    // Ahora retornamos el Observable para poder usarlo más tarde
    this.model.image = imageId;
    return this._imagesService.getModel(imageId);
  }

  private loadStamp(imageId: string): Observable<any> {
    // Igual que con loadImage, retornamos el Observable
    this.model.stamp = imageId;
    return this._imagesService.getModel(imageId);
  }



  //función para detectar solo los elementos que cambian y devolverlos

  private isEqual(value1: any, value2: any): boolean {
    if (typeof value1 !== 'object' && typeof value2 !== 'object') {
      // Si ambos valores no son objetos, se comapran exhaustivamente
      return value1 === value2;
    }
    if (value1 === null || value2 === null || typeof value1 !== 'object' || typeof value2 !== 'object') {
      return false;
    }
    const keys1 = Object.keys(value1);
    const keys2 = Object.keys(value2);
    if (keys1.length !== keys2.length) {
      // Si tienen diferente numerod e propiedades son diferentes
      return false;
    }
    for (const key of keys1) {
      // Comparar cada propiedad
      if (!keys2.includes(key) || !this.isEqual(value1[key], value2[key])) {
        return false;
      }
    }
    // Si todas las propiedades son iguales, entonces los son iguales
    return true;
  }



  private getChanges(): Partial<AppConfiguracionEntorno> {
    const changes: Partial<AppConfiguracionEntorno> = {};
    for (const key in this.originalModel) {
      if (!this.isEqual(this.originalModel[key], this.model[key])) {
        changes[key] = this.model[key];
      }
    }
    return changes;
  }

  private assignImageData(targetData: any, sourceData: any) {

    if (sourceData && targetData) {
      targetData.name = sourceData.name;
      targetData.mimeType = sourceData.mimeType;
      targetData.base64 = sourceData.imageData;
      targetData.base64FullData = `data:${sourceData.mimeType};base64,${sourceData.imageData}`;
    }

  }



  ngOnInit(): void {

    this.conectiaLicence = this.licenseChecker.checkLicense("conectia");
    this.livesHrLicence = this.licenseChecker.checkLicense("livesHR");

    this.environmentID = this._livesSession.EnvironmentId;
    this._modelService.getModel(this.environmentID).subscribe(
      data => {
        this.model.environment1 = data.environment1;
        this.model.pushAcceptText = data.pushAcceptText;
        this.model.pushDenyText = data.pushDenyText;
        this.model.mailAcceptText = data.mailAcceptText;
        this.model.mailDenyText = data.mailDenyText;
        const imageObservable = data.image ? this.loadImage(data.image) : null;
        const stampObservable = data.stamp ? this.loadStamp(data.stamp) : null;
        this.model.customRedirection = data.customRedirection;

        // Utilizamos forkJoin para esperar a que ambas llamadas asincrónicas se completen
        forkJoin([imageObservable, stampObservable]).subscribe(results => {
          // results[0] es la respuesta de loadImage, results[1] es la respuesta de loadStamp
          if (results[0]) {
            this.assignImageData(this.model.imageData, results[0]);
          }
          if (results[1]) {
            this.assignImageData(this.model.stampData, results[1]);
          }


          // Guardamos el estado original del modelo
          this.originalModel = JSON.parse(JSON.stringify(this.model));
          //console.log(this.originalModel)
        });
      },
      error => {
        console.error('Error al obtener el modelo:', error);
      }
    );

  }

  afterModelLoad(): void {
  }

  afterModelUpdated(): void {
    console.log('Model updated');
  }


  handleImageSelected(base64Image: any) {
    this.assignImageData(this.model.imageData, base64Image);
    this.checkFieldsNotEmpty()
  }

  handleStampSelected(base64Stamp: any) {
    this.assignImageData(this.model.stampData, base64Stamp);
    this.checkFieldsNotEmpty()

  }

  handleVisibleCustomButtonChange(event: any): void {
    this.model.customRedirection.showButtonRedirection = event.value;
    this.checkFieldsNotEmpty();

  }

  handleCustomButtonImageChange(event: any): void {
    this.model.customRedirection.image = event.imageData;
    this.checkFieldsNotEmpty();
  }

  handleCustomButtonNameChange(event: any): void {
    this.model.customRedirection.name = event;
    this.checkFieldsNotEmpty();
  }

  handleCustomButtonAndroidUrlChange(event: any): void {
    this.model.customRedirection.androidUrl = event;
    this.checkFieldsNotEmpty();
  }

  handleVisibleCustomIosUrlChange(event: any): void {
    this.model.customRedirection.iosUrl = event;
    this.checkFieldsNotEmpty();
  }


  getModelInstance(): AppConfiguracionEntorno {
    return new AppConfiguracionEntorno();
  }

  validateCustomButtonFields() {
    if (this.model.customRedirection && this.model.customRedirection.showButtonRedirection) {
      this.customButtonImageValid = this.model.customRedirection.image && this.model.customRedirection.image.length > 0;
      this.customButtonNameValid = this.model.customRedirection.name && this.model.customRedirection.name.length > 0;
      this.customButtonAndroidUrlValid = this.customButtonAndroidUrlRegex.test(this.model.customRedirection.androidUrl);
      this.customButtonIosUrlValid = this.customButtonIosUrlRegex.test(this.model.customRedirection.iosUrl);

      return this.customButtonImageValid && this.customButtonNameValid && this.customButtonAndroidUrlValid && this.customButtonIosUrlValid;
    } else {
      return true;
    }
  }

  checkFieldsNotEmpty(): void {
    let changes = this.getChanges();

    if (this.model.pushAcceptText.length > 0 &&
      this.model.pushDenyText.length > 0 &&
      this.model.mailAcceptText.length > 0 &&
      this.model.mailDenyText.length > 0 &&
      this.validateCustomButtonFields()) {
      if (Object.keys(changes).length > 0) {
        this.textFieldsNotEmpty = true;
      } else {
        this.textFieldsNotEmpty = false;
      }
    } else {
      this.textFieldsNotEmpty = false;
    }
  }



  setPushAccept(newValue: string): void {
    this.model.pushAcceptText = newValue;
    this.checkFieldsNotEmpty()
  }

  setPushReject(newValue: string): void {
    this.model.pushDenyText = newValue;
    this.checkFieldsNotEmpty()
  }

  setMailAccept(newValue: string): void {
    this.model.mailAcceptText = newValue;
    this.checkFieldsNotEmpty()
  }

  setMailReject(newValue: string): void {
    this.model.mailDenyText = newValue;
    this.checkFieldsNotEmpty()
  }

  onSubmit() {
    this.checkFieldsNotEmpty();
    if (this.textFieldsNotEmpty) {
      let changes = this.getChanges();

      // Hago los cambios de textos primero
      this._configEntornoService.updateModel(this.model.environment1, changes).subscribe(
        () => {
          // Si hay cambios de imágenes, manejar las actualizaciones
          let imageUpdateObservables = this.prepareImageUpdates(changes);

          // Si no hay actualizaciones de imágenes, mostrar mensaje de éxito
          if (imageUpdateObservables.length === 0) {
            this.showMessage('Datos actualizados', 'Se han actualizado los datos correctamente');
          } else {
            // Esperar a que todas las actualizaciones de imágenes se completen
            forkJoin(imageUpdateObservables).subscribe(
              () => {
                // Todas las actualizaciones de imágenes fueron exitosas
                this.showMessage('Datos actualizados', 'Se han actualizado todos los datos e imágenes correctamente');
              },
              error => {
                // Hubo un error en las actualizaciones de imágenes
                console.error(error)
                this._messageDialog.ShowAlert('Error al enviar', 'Ha habido un error al actualizar las imágenes');
              }
            );
          }
        },
        error => {
          // Hubo un error en la actualización de configuración de entorno
          this._messageDialog.ShowAlert('Error al enviar', 'Ha habido un error al actualizar los datos de configuración');
        }
      );
    }
  }

  // Preparar y obtener un array de observables para las actualizaciones de imágenes
  prepareImageUpdates(changes: any): Observable<any>[] {
    let imageUpdateObservables = [];
    const { imageData, stampData } = changes;

    if (imageData) {
      imageUpdateObservables.push(this._imagesService.updateModel(this.model.image, imageData));
    }
    if (stampData) {
      imageUpdateObservables.push(this._imagesService.updateModel(this.model.stamp, stampData));
    }

    // Limpia las propiedades que ya no son necesarias en el objeto de cambios
    delete changes.imageData;
    delete changes.stampData;
    return imageUpdateObservables;
  }

  // Método genérico para mostrar mensajes
  showMessage(title: string, message: string) {
    this._messageDialog.ShowMessage(message, title);
    this.textFieldsNotEmpty = false;
  }

  showConectiaPopUp() {

    const licenceConnectia: Partial<AppConfiguracionEntorno> = { conectia: true };

    this._messageDialog.ShowQuestionHTML(`
      <p>Será redirigido a la pantalla de configuración de la conexión y allí deberá clicar en el icono <mat-icon style="vertical-align: bottom;" role="img" class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">cached</mat-icon> e iniciar sesión siguiendo los pasos.</p> <p>¿Desea continuar?</p>
      `, 'Conectar con Conectia')
      .then(result => {
        if (result.value) {
          this._configEntornoService.updateModel(this.model.environment1, licenceConnectia).subscribe(
            () => {
              this._livesSession.Conectia = 'true';
              this._router.navigate(['/home/config/administration/conectia']);
            },
            error => {
              // Hubo un error en la actualización de configuración de entorno
              this._messageDialog.ShowAlert('Error al enviar', 'Ha habido un error pruebe de nuevo');
            }
          );
        }
      });

  }

  afterModelCreated(success: boolean): void {
  }
}
